import { render, staticRenderFns } from "./Selector.vue?vue&type=template&id=a4c7baee&scoped=true"
import script from "./Selector.vue?vue&type=script&lang=js"
export * from "./Selector.vue?vue&type=script&lang=js"
import style0 from "./Selector.vue?vue&type=style&index=0&id=a4c7baee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../content-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c7baee",
  null
  
)

export default component.exports